import React, { useState, useEffect } from 'react';
import { Container, Tab, Tabs, Modal} from 'react-bootstrap';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import { getUserPrograms } from '../services/ProgramApi';
import { toast } from 'react-toastify';
import moment from "moment";
import LoadingSpinner from './LoadingSpinner';

const Schedule = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [loading, setLoading] = useState(false); 

  useEffect(() => {
    const fetchUserPrograms = async () => {
      try {
        setLoading(true); 
        const response = await getUserPrograms();
        if (response.data && Array.isArray(response.data)) {
          const { upcoming, past } = transformBookingsToEvents(response.data);
          setUpcomingEvents(upcoming);
          setPastEvents(past);
        } else {
          throw new Error("Unexpected API response format");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to fetch programs");
      } finally {
        setLoading(false); 
      }
    };
    fetchUserPrograms();
  }, []);

  const transformBookingsToEvents = (bookings) => {
    let upcoming = [];
    let past = [];
    const today = moment();

    bookings.forEach((booking) => {
      const { child, program, subscriptions, time_slots } = booking;
      const { start_date, end_date } = subscriptions;

      const validDates = getValidDatesBetween(start_date, end_date, time_slots.map(slot => parseInt(slot.day)));
      validDates.forEach(date => {
        time_slots.forEach(slot => {
          if (moment(date).day() === parseInt(slot.day)) {
            const event = {
              id: `${booking.id}-${date}`,
              title: `${child.child_name} - ${program.program_name}`,
              start: `${date}T${convertTo24Hour(slot.start_time)}`,
              end: `${date}T${convertTo24Hour(slot.end_time)}`,
              description: "",
              location: ""
            };
            if (moment(date).isSameOrAfter(today, 'day')) {
              upcoming.push(event);
            } else {
              past.push(event);
            }
          }
        });
      });
    });
    return { upcoming, past };
  };

  const getValidDatesBetween = (startDate, endDate, validDays) => {
    let dates = [];
    let currentDate = moment(startDate);
    const end = moment(endDate);

    while (currentDate.isSameOrBefore(end)) {
      if (validDays.includes(currentDate.day())) {
        dates.push(currentDate.format("YYYY-MM-DD"));
      }
      currentDate.add(1, "day");
    }
    return dates;
  };

  const convertTo24Hour = (time) => {
    return moment(time, ["h:mm A"]).format("HH:mm:ss");
  };

  const handleEventClick = (info) => {
    setSelectedEvent(info.event);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };

  const handleTabChange = (key) => {
    setLoading(true); 
    setTimeout(() => {
      setLoading(false); 
    }, 200); 
  };

  return (
    <div className='app-container mobile-bottom'>
      <Container>
        <Tabs
          defaultActiveKey="my"
          transition={true}
          id="ProgramsTabs"
          className="mb-3 custom-tabs"
          fill
          onSelect={handleTabChange} 
        >
          <Tab eventKey="my" title="Upcoming Sessions">
            {loading ? (
              <div className="text-center pt-5">
                <LoadingSpinner />
              </div>
            ) : upcomingEvents.length > 0 ? (
              <FullCalendar
                plugins={[timeGridPlugin]}
                initialView="timeGridWeek"
                events={upcomingEvents}
                eventClick={handleEventClick}
                height="450px"
              />
            ) : (
              <div className='text-center pt-5 mt-5'>
                <h4>No upcoming sessions</h4>
              </div>
            )}
          </Tab>

          <Tab eventKey="all" title="Past Sessions">
            {loading ? (
              <div className="text-center pt-5">
                <LoadingSpinner/>
              </div>
            ) : pastEvents.length > 0 ? (
              <FullCalendar
                plugins={[timeGridPlugin]}
                initialView="timeGridWeek"
                events={pastEvents}
                eventClick={handleEventClick}
                height="450px"
              />
            ) : (
              <div className='text-center pt-5 mt-5'>
                <h4>No past sessions</h4>
              </div>
            )}
          </Tab>
        </Tabs>
      </Container>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton className='py-2 bg-warning text-white'>
          <Modal.Title className='fs-16 text-uppercase fw-600'>Program Schedule Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEvent && (
            <>
              <p className='mb-2'><strong>Title:</strong> {selectedEvent.title}</p>
              <p className='mb-2'><strong>Start:</strong> {new Date(selectedEvent.start).toLocaleString()}</p>
              <p className='mb-2'><strong>End:</strong> {new Date(selectedEvent.end).toLocaleString()}</p>
              {/* <p className='mb-2'><strong>Description:</strong> {selectedEvent.extendedProps?.description || 'No description available'}</p>
              <p className='mb-2'><strong>Location:</strong> {selectedEvent.extendedProps?.location || 'No location specified'}</p> */}
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Schedule;